export default __webpack_public_path__ + "static/media/esterilizacion_a_costo_mayo22.cea80ec0.jpg";